<template>
  <div class="hello">
    <div class="helloTop">
      <div class="UpOne">现在完成注册 即可获取30天免费试用 !</div>

      <div class="con2">
        <div class="con3" v-for="(item,i) in items" :key="i">
          <div class="con4">{{ item.age }}</div>
          <div class="con5">{{ item.components }}</div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: "Upgrade",
  data() {
    return {
      items:[
            {age:'30天',components:'注册免费试用'},
            {age:'50%',components:'业绩增长'},
            {age:'20%',components:'降低成本'},
            {age:'2倍',components:'效率提升'},
        ]
    }
  }
}
</script>

<style lang="scss" scoped>

.con2{
  height: 265px;
  width: 100%;
  display: flex;
}

.con3{
  width: 25%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

}
.con4{
  height: 56px;
  font-size: 40px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #EB5B05;
  line-height: 47px;
  margin-bottom: 30px;
}
.con5{
  height: 24px;
  font-size: 24px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 24px;
}

















.hello {
  width: 100%;
  display: flex;
  justify-content: center;

  // background: linear-gradient(90deg, #f7f8fc 0, #ebf8fe 100%);
  .helloTop {
    width: 1200px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .UpOne {
      margin: 90px 0 8px;
      height: 56px;
      font-size: 40px;
      font-weight: 500;
      color: #121221;
      line-height: 47px;
    }
  }
}
</style>
